export default __webpack_public_path__ + "static/media/student_contact.7370c64b.png";